import styled from "styled-components";

const TabsStyled = styled.div`
  display: flex;
  justify-content: space-between;
  border: ${props => props.theme.lightGrayBorder};
  border-radius: 0.5rem;
  width: 100%;
  background-color: transparent;
`;

export default TabsStyled;
